module.exports = __webpack_public_path__ + "img/yywy-4.98534f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/yywy-4.jpg
// module id = OG1K
// module chunks = 0